import { FormatHelper } from '../../../../../../../../../services/utils/FormatHelper';
import { defaultTableCellRenderer, TableCellProps } from 'react-virtualized';
import React from 'react';
import { ICurrencyFormatter } from '../../../../../../../../../services/selectors/portfolio';

function formatNumber(num: number) {
  if (num) {
    return num
      .toFixed(0)
      .toString()
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }
  return num;
}

function getCellValue(cellName: string, cellValue: string | number, calculated: boolean): string | number {
  switch (cellName) {
    case 'percentage':
      return cellValue ? FormatHelper.formatPercentage(Number(cellValue), 100) : 0;
    case 'portfolioPercentage':
      return cellValue ? FormatHelper.formatPercentage(Number(cellValue), 100) : 0;
    default:
      return cellValue;
  }
}

export const cashCellRenderer = (
  data: TableCellProps,
  portfolioCurrencyFormatter: ICurrencyFormatter
): React.ReactNode => {
  if (data.dataKey === 'marketValueLocal') {
    return (data.cellData = `${formatNumber(data.cellData)} ${data.rowData.currency.name} `);
  }

  if (data.dataKey === 'marketValueBase') {
    return (data.cellData = `${portfolioCurrencyFormatter()} ${formatNumber(data.cellData)}`);
  }

  data.cellData = getCellValue(data.dataKey, data.cellData, data.rowData.calculated);
  return defaultTableCellRenderer(data);
};
